module.exports = __webpack_public_path__ + "img/about-div.28cbba37.png";